const styles = {
    iconStyle:{
        backgroundColor: 'transparent',
        borderRadius: 0,
        width: 25,
        display: 'initial'
    }
};
export default styles;


// WEBPACK FOOTER //
// ./src/components/crashDashboard/styles/severityPinLegendStyles.js